import { get } from 'lodash'
import { ContractDurationType, DiscountType } from '../../../../types/flyout'
import type { ViewResellerAuthorizationType } from '../../../../modules/receivedResellerAuthorization/types'
import { getPricesArray } from '../../../../modules/resaleAuthorization/action'
import type { Dimension } from '../../../../modules/privateOffer/reducer'

export const getContractDurationForEndCustomer = (
  resellerAuthorization: ViewResellerAuthorizationType,
  isReceived = false
) => {
  if (
    resellerAuthorization?.contractDurationType ===
      ContractDurationType.CUSTOM ||
    resellerAuthorization?.discountType === DiscountType.FLEXIBLE_PAYMENT_TERMS
  ) {
    return resellerAuthorization?.contractDurationInMonthsForEndCustomer
      ? `${
          resellerAuthorization?.contractDurationInMonthsForEndCustomer
        } month${
          resellerAuthorization?.contractDurationInMonthsForEndCustomer > 1
            ? 's'
            : ''
        }`
      : ''
  }
  const priceMonths = ['price12m', 'price24m', 'price36m']
  const pricesArray = getPricesArray(
    get(
      resellerAuthorization,
      isReceived ? 'dimensions' : 'products[0].dimensions',
      []
    ) as Dimension[]
  ).map(item =>
    item
      ?.replace('m', priceMonths.includes(item) ? ' months' : ' month')
      .replace('price', '')
  )
  return pricesArray?.join(', ')
}
